import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  eVoucherList: {
    list: {
      data: [],
      total: 0,
    },
  },
  eVoucherData: {},
  evoucherActivationRequestData: {
    data: {},
  },
}

export default {
  state,
  actions,
  mutations,
  getters,
}
